<template>
  <div>
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="昵称/手机号">
          <el-input v-model="formInline.nickName" placeholder="请输入昵称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="userName" label="用户名" width="180">
      </el-table-column>
      <el-table-column prop="oldGradeName" label="旧等级" width="180">
      </el-table-column>
      <el-table-column prop="newGradName" label="新等级">
      </el-table-column>
      <el-table-column prop="dateTypeName" label="时效">
      </el-table-column>
      <el-table-column prop="operatorUser" label="操作人">
      </el-table-column>
      <el-table-column prop="createTime" label="操作时间">
      </el-table-column>
    </el-table>


    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
        :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
  import WifiApi from '@/api/wifi';
  import {
    getCookie
  } from '@/utils/base.js';
  import qs from "qs";
  export default {
    data() {
      return {
        tableData: [],
        formInline: {
          nickName: ''
        },
        /*一页多少条*/
        pageSize: 10,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*是否加载完成*/
        loading: true,
      }
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        self.curPage = 1;
        self.getTableList();
      },
      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.pageIndex = self.curPage;
        Params.pageSize = self.pageSize;
        WifiApi.wifiUserGradeLog(Params, true)
          .then(res => {
            self.loading = false;
            self.tableData = res.data.records;
            self.totalDataNumber = res.data.total;
            self.gradeList = res.data.gradeList;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },
      onExport: function() {
        let self = this;
        let Params = self.formInline;
        Params.token = getCookie('token');
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/api/shop/iot/grade/exportWifiUserGradeLog?' + qs.stringify(Params);
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/user/wifigradelog/index.vue